import { ComponentProps } from 'react'
import { Details } from '../Details/Details' // Import the Details component

type DetailsCardProps = {
    title?: string
    items: ComponentProps<typeof Details>['items']
}

export const DetailsCard: React.FC<DetailsCardProps> = ({ title, items }) => {
    return (
        <div className="space-y-2 rounded-xl border border-neutral-200 p-4">
            {title && <h2 className="text-heading-7 text-regular">{title}</h2>}
            <Details items={items} />
        </div>
    )
}
